document.addEventListener("DOMContentLoaded", function() {
  const featureVideos = document.querySelectorAll('.feature-video, .js-video');

  if(featureVideos.length) {
    const resizeVideoForLandscape = function(){
      if(window.innerHeight < window.innerWidth && window.innerWidth < 1024){
        Array.prototype.forEach.call(featureVideos, (el) => {
          const video = el.querySelector('.feature-video__video');
          const videoSimple = el;
          if (video) {
            video.classList.add('mobile-landscape');
          } else if (videoSimple) {
            videoSimple.classList.add('mobile-landscape');
          }
        })
      }
    }

    resizeVideoForLandscape();

    window.addEventListener('onorientationchange', resizeVideoForLandscape, true);
    $(window).smartresize(() => {
      resizeVideoForLandscape();
    })
  }
})
